const messageType = {
    PATIENT: 0,
    MEDIC:1,
    NURSE: 2,
    BROADCAST : 3,
    SURVEY: 4
}

export default messageType;